import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import "./user.scss";

import UserForm from "./Form/UserForm";
import UserService from "../../services/UserService";

export default function AddUser() {
  // const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const history = useHistory();

  let initialValues = {
    nome: "",
    email: "",
    senha: "",
  };

  const send = (user) => {
    setLoading(true);
    UserService.register(user)
      .then((response) => {
        let status =
          response && response.response && response.response.status
            ? response.response.status
            : "";
        if (status !== "") {
          if (
            response &&
            response.response &&
            response.response.data &&
            response.response.data.message
          ) {
            setError(response.response.data.message);
          }

          setSuccess(false);
          setLoading(false);
          setRedirect(false);
          return false;
        }

        setLoading(false);
        setSuccess(true);
        setError(false);
        setRedirect(true);
      })
      .catch((error) => {
        setLoading(false);
        setSuccess(false);
        setError(true);
        setRedirect(false);
      });
  };

  if (redirect) {
    history.push("/login", { params: redirect });
  }

  return (
    <UserForm
      title="Cadastro"
      initialValues={initialValues}
      send={send}
      error={error}
      success={success}
      loading={loading}
    />
  );
}
